import { duration, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const FontChatButtonStyle: StyleExtend<Theme> = {
  position: 'fixed',
  bottom: 0,
  right: (theme) => theme.spacing(2),
  zIndex: (theme) => theme.zIndex.appBar + 1,
  '& svg rect': {
    transitionProperty: `fill`,
    transitionDuration: `${duration.standard}ms`,
  },
  '&:hover': {
    backgroundColor: 'transparent',
    '& svg rect': { fill: (theme) => theme.palette.secondary.dark },
  },
};
